// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__7sS63","location":"Header_location__3Pl8v"};